<template>
  <div
    id="divView"
    class="divView">
    <fieldset>
      <a
        href="javascript: void 0"
        @click="clicked">
        <img
          v-if="view === 'Map'"
          id="mapIcon"
          src="./assets/map-selected.png"
          alt="Map is currently displayed">
        <img
          v-else
          id="mapIcon"
          src="./assets/map-unselected.png"
          alt="Display map">
      </a>
      <a
        href="javascript: void 0"
        @click="clicked">
        <img
          v-if="view === 'Chart'"
          id="chartIcon"
          src="./assets/chart-selected.png"
          alt="Chart is currently displayed">
        <img
          v-else
          id="chartIcon"
          src="./assets/chart-unselected.png"
          alt="Display chart">
      </a>
      <a
        href="javascript: void 0"
        @click="clicked">
        <img
          v-if="view === 'Table'"
          id="tableIcon"
          src="./assets/table-selected.png"
          alt="Table is currently displayed">
        <img
          v-else
          id="tableIcon"
          src="./assets/table-unselected.png"
          alt="Display table">
      </a>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ViewButtons',
  // Note: button icons images are mananged as webpack module dependencies.
  // See http://vuejs-templates.github.io/webpack/static.html
  // for more info.
  computed: {
    ...mapState({
      view: state => state.LP.view,
      stratFilters: state => state.LP.stratFilters,
      // compareId: state => state.LP.stratFilters.compareId,
    }),
    stratFiltersHasAll() {
      const {
        stratId1, stratCatId2, stratId2, responseId,
      } = this.stratFilters;
      return (stratId1 === '') || (stratCatId2 && stratId2 === '') || (responseId === '');
    },
  },
  methods: {
    setInteractionTypeIfEmpty(val) {
      this.$store.commit('LP/setInteractionTypeIfEmpty', val);
    },
    clicked(evt) {
      // evt.target is the image if clicked via the mouse
      // or the anchor tag if selected via the enter key
      const id = evt.target.id || evt.target.getElementsByTagName('img')[0].id;
      let newView = this.view;
      switch (id) {
        case 'mapIcon':
          newView = 'Map';
          break;
        case 'chartIcon':
          newView = 'Chart';
          break;
        case 'tableIcon':
          newView = 'Table';
          break;
        default:
          throw new Error(`Unexpected icon id: ${id}`);
      }

      if (newView !== this.view) {
        this.$store.commit('LP/setVisualizationChanged', true);
        if (newView === 'Map') {
          if (this.stratFiltersHasAll) {
            // switching to map will cause the strat filters to update because the All
            // in the strat filters will be removed
            this.setInteractionTypeIfEmpty('IV');
          } else {
            // trigger interaction w/o strat filter update
            this.setInteractionTypeIfEmpty('IVNoUpdate');
          }
        } else {
          // currently switching to Chart or Table from the Map will not cause the strat filters to update
          // this may change in the future
          this.setInteractionTypeIfEmpty('IVNoUpdate');
        }
        this.$store.commit('LP/setView', newView);
        this.$store.getters['LP/setBrowserUrlBarToReflectCurrentLPState'](this.$router);
      }
    },
  },

};

</script>

<style scoped>
  .divView {
    font-size: 0;
    margin: 10px 10px;
  }

  .divView a {
    display: inline-block;
    height: 29px;
  }

  fieldset {
    border: 0;
    padding: 0.01em 0 0 0;
    margin: 0;
    min-width: 0;
    height: 29px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LP/ViewButtons.vue